import Cookies from 'js-cookie';

export default {
  init() {
    /**
     * Back to plans
     */
    if (Cookies.get('back-to-plans')) {
      $('.unit__back a').attr('href', Cookies.get('back-to-plans'));
    }

    /**
     * Floor image popup
     */
    if ($('.unit__floor-image').length) {
      $('#modal-floor-image').appendTo('body');

      $('#modal-floor-image').on('show.bs.modal', function () {
        $('body').addClass('modal-open--gallery');
      });

      $('#modal-floor-image').on('hidden.bs.modal', function () {
        $('body').removeClass('modal-open--gallery');
      });

      $('.unit__floor-image').appendTo('.wp-block-gallery');
      $('.unit__floor-image').click(function (e) {
        e.preventDefault();
        $('#modal-floor-image').modal('show');
      });
    }

    /**
     * Save unit title in form
     */
    $('#acf-field_form_unit_unit').val($('h1').text());
  },
};
